import { useCallback } from 'react';
import { useAppDispatch } from '../redux/hooks';
import { addToCart, openCart } from '../redux/slices/cartSlice';
import { createCartItem } from '../utils/cartUtils';

interface UseComboCartOptions {
  autoOpenCart?: boolean;
}

/**
 * Reusable hook for handling combo item cart operations
 * Consolidates combo cart logic using createCartItem helper
 */
export const useComboCart = (options: UseComboCartOptions = {}) => {
  const { autoOpenCart = false } = options;
  const dispatch = useAppDispatch();

  /**
   * Add combo item to cart
   * Transforms combo structure to menu item structure and uses createCartItem
   */
  const handleComboAddToCart = useCallback((combo: any) => {
    // Parse combo price
    const parsedPrice = typeof combo.combo_price === "string"
      ? parseFloat(combo.combo_price.replace(/[^0-9.-]+/g, ""))
      : combo.combo_price;
    const comboPrice = isNaN(parsedPrice) ? 0 : parsedPrice;
    
    // Transform combo to match menu item structure for createCartItem
    const comboAsMenuItem = {
      ...combo,
      pk_id: combo.combo_id,           // Transform combo_id → pk_id
      name: combo.title,                // Transform title → name
      price: comboPrice.toString(),     // Ensure price is string
    };
    
    // Use createCartItem helper - no manual object creation needed
    const cartItem = createCartItem(comboAsMenuItem, null, [], 1);
    
    dispatch(addToCart(cartItem));
    
    // Feature flag: only open cart if enabled
    if (autoOpenCart) {
      dispatch(openCart());
    }
  }, [dispatch, autoOpenCart]);

  return { handleComboAddToCart };
};
